import { useEffect, useState } from 'react';
import { ApiError } from '../../../shared/shared.api';
import { listReports, type ReportSummary } from '../reports.api';

export type ReportSummariesState =
  { status: 'loading' } | { status: 'loaded'; reports: ReportSummary[] } | { status: 'forbidden' } | { status: 'error'; error: unknown };

/** The registered reports: the list screen's rows, and each report screen's declared filters, columns and freshness. */
export function useReportSummaries(): ReportSummariesState {
  const [state, setState] = useState<ReportSummariesState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;
    listReports()
      .then((reports) => {
        if (!cancelled) setState({ status: 'loaded', reports });
      })
      .catch((error: unknown) => {
        if (!cancelled) setState(error instanceof ApiError && error.status === 403 ? { status: 'forbidden' } : { status: 'error', error });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
